import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import logo from '../../assets/mtlawllc-logo-header.png';

export const Root = styled(Box)({
    color: '#9B9B9B',
    background: 'linear-gradient(180deg, #D8E8EF 0%, #C7D6E2 100%)',
    minHeight: '100vh',
    '& .content': {
        paddingTop: '74px',
        width: '100%',
    },
    '& .card': {
        marginTop: '40px',
        width: '800px',
        backgroundColor: '#fff',
    },
    '& .logo': {
        width: '187px',
        height: '43px',
        background: `url(${logo}) no-repeat center top/cover`,
    },
    '& .line': {
        width: '100%',
        height: '1px',
        margin: '45px 0 40px 0 ',
        backgroundColor: '#A1A1A1',
        opacity: '0.13',
    },
    '& .completeWapper': {
        width: '100%',
        height: '100%',
        '& .complete': {
            marginTop: '100px',
            width: '600px',
            height: '150px',
            padding: '40px',
            color: '#005E96',
            backgroundColor: '#fff',
            '& .text': {
                marginLeft: '10px',
                fontSize: '16px',
                fontWeight: 'bold',
            }
        }
    },
    '& .refealBtn': {
        backgroundColor: '#C1553A !important',
        color: '#fff',
        marginRight: '20px',
    },
});